// extracted by mini-css-extract-plugin
export default {"userArea":"userArea_userArea__qyqp6","callSubscriptionsButton":"userArea_callSubscriptionsButton__DwDV1"};